import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    admin: JSON.parse(localStorage.getItem('admin_info') || 'null'),
    token: localStorage.getItem('admin_token') || ''
  },
  getters: {
    isLoggedIn: state => !!state.token,
    role: state => state.admin?.role,
    storeId: state => state.admin?.store_id,
    isSuperAdmin: state => state.admin?.role === 0 || state.admin?.is_super === true,
    isStoreAdmin: state => state.admin?.role === 2
  },
  mutations: {
    // 登录响应 d 中包含: token, account, real_name, role, role_name, store_id, is_super
    SET_ADMIN(state, { token, account, real_name, role, role_name, store_id, is_super }) {
      const admin = { account, real_name, role, role_name, store_id, is_super, username: account }
      state.admin = admin
      state.token = token
      localStorage.setItem('admin_token', token)
      localStorage.setItem('admin_info', JSON.stringify(admin))
    },
    LOGOUT(state) {
      state.admin = null
      state.token = ''
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
    }
  }
})
